import { render, staticRenderFns } from "./DistanceBonusTab.vue?vue&type=template&id=0a5bb788&scoped=true&"
import script from "./DistanceBonusTab.vue?vue&type=script&lang=js&"
export * from "./DistanceBonusTab.vue?vue&type=script&lang=js&"
import style0 from "./DistanceBonusTab.vue?vue&type=style&index=0&id=0a5bb788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5bb788",
  null
  
)

export default component.exports